import { IonDatetime } from "@ionic/react";
import dayjs from "dayjs";
import "dayjs/locale/es";
import React from "react";

export interface FechaFutura {
  date: string;
  textColor: string;
  backgroundColor: string;
}

interface DateTimePickerProps {
  fechaSeleccionada: string;
  handleChangeFecha: (value: string) => void;
  fechasFuturas: string[];
}

export const CalendarPicker: React.FC<DateTimePickerProps> = ({ fechaSeleccionada, handleChangeFecha, fechasFuturas }) => {
  const HabilitarFecha = (date: string) => {
    return fechasFuturas.some((fecha) => dayjs(fecha).unix() === dayjs(date).unix());
  };

  const formatDates = (fechas: string[]): FechaFutura[] => {
    return fechas.map((fecha) => {
      return { date: fecha, textColor: "var(--ion-color-tertiary)", backgroundColor: "var(--ion-color-light)" };
    });
  };

  return (
    <IonDatetime
      presentation="date"
      //@ts-ignore
      onIonChange={(e) => handleChangeFecha(e.detail.value)}
      min={dayjs(dayjs()).subtract(1, "years").format("YYYY-MM-DD")}
      max={dayjs(dayjs()).add(3, "months").format("YYYY-MM-DD")}
      value={fechaSeleccionada}
      highlightedDates={formatDates(fechasFuturas)}
      isDateEnabled={HabilitarFecha}
    />
  );
};
